// extracted by mini-css-extract-plugin
var _1 = "_FKGmMYEC9";
var _2 = "pQsq1HUkx1";
var _3 = "J0g_T_GyfH";
var _4 = "Fl6gzFEkmi";
export { _1 as "disabled", _2 as "icon", _3 as "label", _4 as "root" }
